import { render } from "./자원봉사활동.vue?vue&type=template&id=ff3d6404"
import script from "./자원봉사활동.vue?vue&type=script&lang=js"
export * from "./자원봉사활동.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__